import {
    Create,
    Edit,
    EditButton,
    FunctionField,
    List,
    ReferenceField,
    ReferenceInput,
    required,
    SelectInput,
    SimpleForm,
    TextField,
    TextInput
} from 'react-admin';
import AdminPagination from '../AdminPagination';
import AdminSelectableDatagrid from '../AdminSelectableDatagrid';
import { ResourceListTitle } from '../AdminResourceTotalCount';
import HumanDeleteButton from '../HumanDeleteButton';
import HumanRecordTitle from '../HumanRecordTitle';
import {
    ContentCatalogMembershipInputs,
    DemoStatusCheckbox,
} from '../ContentCatalogMembershipInputs';

const userFilters = [
    <TextInput source="all" label="Rechercher" alwaysOn />
];

export const InterludeList = (props) => {
    const demoMode = Boolean(props.demoMode);

    return (
        <List
            title={
                <ResourceListTitle
                    resource="interlude"
                    label={
                        demoMode
                            ? "Sons Interlude — Démo"
                            : "Sons Interlude"
                    }
                    queryString={`category_is_demo=${demoMode}`}
                />
            }
            {...props}
            filter={{ category_is_demo: demoMode }}
            filters={userFilters}
            bulkActionButtons={false}
            sort={{ field: 'category_id', order: 'ASC' }}
            perPage={50}
            pagination={<AdminPagination />}
            exporter={false}
        >
            <AdminSelectableDatagrid>
                <ReferenceField
                    label="Catégorie"
                    source="category_id"
                    reference="interludecategory"
                >
                    <FunctionField render={(record) => record!.name} />
                </ReferenceField>

                <TextField source="name" label="Nom" />

                <EditButton />

                <HumanDeleteButton
                    fields={["name"]}
                    fallback="cet interlude"
                />
            </AdminSelectableDatagrid>
        </List>
    );
};

export const InterludeEdit = (props) => {
    const demoMode = Boolean(props.demoMode);

    return (
        <Edit
            {...props}
            mutationMode="pessimistic"
            title={<HumanRecordTitle fields={["name"]} fallback="Fiche" />}
        >
            <SimpleForm redirect={props.basePath || 'list'}>
                <TextInput
                    source="name"
                    label="Nom"
                    validate={required()}
                />

                <TextInput
                    source="video"
                    label="Vidéo"
                    validate={required()}
                />

                <DemoStatusCheckbox
                    demoMode={demoMode}
                />

                <ContentCatalogMembershipInputs
                    defaultStandard={!demoMode}
                />

                <ReferenceInput
                    label="Catégorie"
                    source="category_id"
                    reference="interludecategory"
                    filter={{ is_demo: demoMode }}
                >
                    <SelectInput
                        optionText={(record) => `${record.name}`}
                    />
                </ReferenceInput>
            </SimpleForm>
        </Edit>
    );
};

export const InterludeCreate = (props) => {
    const demoMode = Boolean(props.demoMode);

    return (
        <Create {...props}>
            <SimpleForm redirect={props.basePath || 'list'}>
                <TextInput
                    source="name"
                    label="Nom"
                    validate={required()}
                />

                <TextInput
                    source="video"
                    label="Vidéo"
                    validate={required()}
                />

                <DemoStatusCheckbox
                    demoMode={demoMode}
                />

                <ContentCatalogMembershipInputs
                    defaultStandard={!demoMode}
                />

                <ReferenceInput
                    label="Catégorie"
                    source="category_id"
                    reference="interludecategory"
                    filter={{ is_demo: demoMode }}
                >
                    <SelectInput
                        optionText={(record) => `${record.name}`}
                    />
                </ReferenceInput>
            </SimpleForm>
        </Create>
    );
};
